// @flow
import React, {useState, useMemo, useEffect} from 'react';
import {
  Tab,
  Tabs,
  makeStyles,
  Divider,
  Typography,
  IconButton,
  Chip,
  Snackbar,
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {Add, Tune, ArrowBack, Close} from '@material-ui/icons';
import {colors} from '../../../../assets/styles/colors';
import {useLocation, Link, Switch, Route} from 'react-router-dom';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import FilterModal from '../logistics/components/FilterModal';
import LogisticPickupNewNational from './LogisticsPickupNewNational';
import LogisticPickupNewInternational from './LogisticsPickupNewInternational';
import CardPickup from './components/CardPickup';
import {
  useCreateLogisticPickupRate,
  useEnabledLogisticPickup,
  // useGetAvailableShippingCountries,
  useResetState,
  useUpdateEnabledPickupMethod,
} from './utils';
import {useStoreCountry} from '../../../country/utils';
import {useCountries} from '../../../../modules/country/utils';
import {customErrorMessage} from '../logistics/utils/customErrorMessage';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    borderRadius: '12px',
  },
  subRouteHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    border: '1px solid #e5e6e7',
  },
  subRouteTitle: {
    marginLeft: theme.spacing(1),
    fontSize: '1rem',
    fontWeight: 600,
  },
  contentBackground: {
    backgroundColor: '#fcfcfd',
    // padding: '0px 16px 16px 16px',
    borderRadius: '12px',
    border: `1px solid #e5e6e7`,
  },
  contentTabs: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tabs: {
    width: 'fit-content',
  },
  tabButton: {
    color: colors.grey600,
    textTransform: 'none',
  },
  tabSelected: {
    color: colors.grey900,
    textTransform: 'none',
  },
  divider: {
    background: '#e8e8ed',
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  newRate: {
    width: '100%',
    border: `2px dashed ${colors.grey300}`,
    borderRadius: '8px',
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    color: colors.grey700,
    fontWeight: 400,
  },
  backgroundButton: {
    backgroundColor: colors.grey300,
    borderRadius: '50%',
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  filterButton: {
    background: 'transparent',
    border: '1px solid #E0E0E0',
    color: colors.grey600,
    paddingInline: theme.spacing(2),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingInline: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  containerData: {
    backgroundColor: '#f9f9fb',
    borderRadius: '8px',
    padding: theme.spacing(2),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    borderRadius: '8px',
    gap: theme.spacing(1),
  },
  textGrey: {
    color: colors.grey600,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  textHeaderName: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonsHeader: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  bold: {
    fontWeight: 600,
  },
  check: {
    backgroundColor: '#ccf0e6',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    height: '19px',
    width: '19px',
    padding: '12px',
    justifyContent: 'center',
    cursor: 'pointer',

    '& svg': {
      color: '#007f5d',
      fontSize: '19px',
      fontWeight: 600,
    },
  },
  notCheck: {
    padding: '11px',
    backgroundColor: '#ffffff',
    border: '1px solid #d4d4dd',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    height: '19px',
    width: '19px',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  deleteButton: {
    color: colors.error,
  },
  editButton: {
    color: colors.grey600,
  },
  chipCountry: {
    backgroundColor: colors.grey300,
    color: colors.grey700,
    padding: theme.spacing(1),
    borderRadius: '8px',
    width: 'fit-content',
    fontWeight: 600,
    height: '25px',
    textTransform: 'uppercase',
  },
  containerBackground: {
    paddingInline: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderLeft: '1px solid #dbdbe0',
    borderRight: '1px solid #dbdbe0',
    borderBottom: '1px solid #dbdbe0',
    paddingBottom: '22px',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
}));

type SubRoute = {
  name: string,
  path: string,
  enabled?: boolean,
  disabled?: boolean,
  component?: () => any,
  id?: string,
  hide?: boolean,
  id2?: string,
};

export default function LogisticsPickup() {
  const classes = useStyles();
  const location = useLocation();

  const country = useStoreCountry();
  const countries = useCountries();

  const [tabValue, setTabValue] = useState('national');
  const [openModalFilter, setOpenModalFilter] = useState(false);
  const {pickupMethod, fetchLogisticPickup} = useEnabledLogisticPickup();
  const {
    messageError,
    savingEnabledSuccess,
    savingEnabledError,
  } = useUpdateEnabledPickupMethod();
  const {savingSuccess} = useCreateLogisticPickupRate();
  // const availableShippingCountries = useGetAvailableShippingCountries();
  const {resetState} = useResetState();

  const [addresses, setAddresses] = useState();
  const [alertOpenMethod, setAlertOpenMethod] = useState(false);
  const [alertOpenError, setAlertOpenError] = useState(false);
  const [filter, setFilter] = useState({});

  const handleFilter = filter => {
    setFilter(filter);
  };

  const handleCloseModal = () => {
    setOpenModalFilter(false);
  };

  const subRoutes: {[key: string]: SubRoute} = useMemo(
    () => ({
      national: {
        name: 'Agregar Dirección de Tienda Nacional',
        path: '/configure/logistics/pickup/national/new',
        component: LogisticPickupNewNational,
        id: 'advanced-shipping-national',
        id2: 'advanced-shipping-configuration',
      },
      international: {
        name: 'Agregar Dirección de Tienda Internacional',
        path: '/configure/logistics/pickup/international/new',
        component: LogisticPickupNewInternational,
        id: 'advanced-shipping-international',
        id2: 'advanced-shipping-configuration',
      },
    }),
    []
  );

  // const isAvailableOtherCountries =
  //   availableShippingCountries &&
  //   availableShippingCountries.filter(
  //     countryI => countryI.code !== country?.code
  //   ).length > 0;

  const subRoutesArray = Object.keys(subRoutes)
    .map(k => subRoutes[k])
    .filter((route: SubRoute) => !route.hide);

  const subRoute: ?SubRoute = subRoutesArray.find(
    (route: SubRoute) => location.pathname === route.path
  );

  const passesFilter = (rate, filter) => {
    if (!filter || Object.keys(filter).length === 0) {
      return true;
    }

    if (filter.countryCode && filter.countryCode !== rate.country.code) {
      return false;
    }

    if (filter.admin1 && filter.admin1.adminId) {
      if (rate.admin1.admin1Id !== filter.admin1.adminId) {
        return false;
      }
    }

    if (filter.admin2 && filter.admin2.adminId) {
      if (rate.admin2.admin2Id !== filter.admin2.adminId) {
        return false;
      }
    }

    if (filter.admin3 && filter.admin3.adminId) {
      if (rate.admin3.admin3Id !== filter.admin3.adminId) {
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    const totalAddress = {};
    if (pickupMethod && country && pickupMethod.addresses) {
      pickupMethod.addresses.forEach(address => {
        const countryCode = address.country?.code ?? country?.code;
        if (!totalAddress[countryCode]) {
          totalAddress[countryCode] = [];
        }
        totalAddress[countryCode].push(address);
      });
    }
    setAddresses(totalAddress);
  }, [country, pickupMethod]);

  useEffect(() => {
    if (savingEnabledSuccess || savingSuccess) {
      setAlertOpenMethod(true);
    }
  }, [savingEnabledError, savingEnabledSuccess, savingSuccess]);

  useEffect(() => {
    if (savingEnabledError) {
      setAlertOpenError(true);
    }
  }, [savingEnabledError]);

  useEffect(() => {
    fetchLogisticPickup();
  }, [fetchLogisticPickup]);

  useEffect(() => {
    return () => {
      resetState();
    };
  }, [resetState, tabValue]);

  return (
    <>
      <Snackbar
        open={alertOpenMethod}
        autoHideDuration={4000}
        onClose={() => setAlertOpenMethod(false)}
      >
        <Alert severity="success" onClose={() => setAlertOpenMethod(false)}>
          Configuración guardada correctamente
        </Alert>
      </Snackbar>
      <Snackbar
        open={alertOpenError}
        autoHideDuration={4000}
        onClose={() => setAlertOpenError(false)}
      >
        <Alert severity="error" onClose={() => setAlertOpenError(false)}>
          {customErrorMessage(messageError)}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        {subRoute && (
          <>
            <div className={classes.subRouteHeader}>
              <IconButton
                variant="contained"
                size="small"
                component={Link}
                to={`/configure/logistics/pickup${window.location.search}`}
              >
                <ArrowBack />
              </IconButton>
              <Typography className={classes.subRouteTitle} id={subRoute.id2}>
                {subRoute.name}
              </Typography>
            </div>
            {/* <Divider className={classes.divider} /> */}
          </>
        )}

        <Switch>
          <Route exact path="/configure/logistics/pickup">
            <div className={classes.containerBackground}>
              <div className={classes.contentBackground}>
                <div className={classes.contentTabs}>
                  <Tabs
                    value={tabValue}
                    onChange={(event, newValue) => {
                      setTabValue(newValue);
                      setFilter({});
                    }}
                    aria-label=""
                    className={classes.tabs}
                    variant="fullWidth"
                    indicatorColor="primary"
                  >
                    <Tab
                      className={`${classes.tabButton} ${
                        tabValue === 'national' ? classes.tabSelected : ''
                      }`}
                      value="national"
                      label="Nacionales"
                    />
                    <Tab
                      // disabled={!isAvailableOtherCountries}
                      className={`${classes.tabButton} ${
                        tabValue === 'international' ? classes.tabSelected : ''
                      }`}
                      value="international"
                      label="Internacionales"
                    />
                  </Tabs>
                  <div className={classes.buttonsHeader}>
                    {Object.keys(filter).length > 0 && (
                      <CustomButton
                        className={classes.filterButton}
                        color="default"
                        startIcon={<Close />}
                        onClick={() => setFilter({})}
                      >
                        Borrar filtros
                      </CustomButton>
                    )}

                    <CustomButton
                      className={classes.filterButton}
                      color="default"
                      startIcon={<Tune />}
                      onClick={() => setOpenModalFilter(true)}
                    >
                      Filtros
                    </CustomButton>
                  </div>
                </div>

                <Divider className={classes.divider} />

                <div className={classes.container}>
                  {tabValue === 'national' &&
                  addresses &&
                  country &&
                  addresses[country.code] ? (
                    addresses[country.code].filter(rate =>
                      passesFilter(rate, filter)
                    ).length > 0 ? (
                      addresses[country.code]
                        .filter(rate => passesFilter(rate, filter))
                        .map(rate => (
                          <CardPickup
                            rate={rate}
                            isNational={true}
                            classes={classes}
                            key={`national-${rate.id}`}
                          />
                        ))
                    ) : (
                      <Typography>No se encontraron resultados</Typography>
                    )
                  ) : null}

                  {tabValue === 'international' && addresses && countries && (
                    <>
                      {countries
                        .filter(countryII => countryII.code !== country.code)
                        .map(countryI => {
                          const filteredRates =
                            addresses[countryI.code]?.filter(rate =>
                              passesFilter(rate, filter)
                            ) || [];
                          return (
                            filteredRates.length > 0 && (
                              <div
                                className={classes.container}
                                key={`country-internationalI-${countryI.code}`}
                              >
                                <Chip
                                  label={countryI.name}
                                  className={classes.chipCountry}
                                  key={`country-international-${countryI.code}`}
                                />
                                {filteredRates.map(rate => (
                                  <CardPickup
                                    rate={rate}
                                    isNational={false}
                                    classes={classes}
                                    key={`international-${rate.id}`}
                                  />
                                ))}
                              </div>
                            )
                          );
                        })}
                    </>
                  )}

                  <CustomButton
                    classes={{
                      root: classes.newRate,
                    }}
                    color="default"
                    startIcon={
                      <div className={classes.backgroundButton}>
                        <Add />
                      </div>
                    }
                    to={
                      tabValue === 'national'
                        ? `/configure/logistics/pickup/national/new`
                        : `/configure/logistics/pickup/international/new`
                    }
                    // component={Link}
                    // disabled={isSaving || !enabled || hasShippingMethodFeatureDisabled}
                  >
                    Agregar una tarifa
                  </CustomButton>
                </div>
              </div>
            </div>
          </Route>
          {subRoutesArray.map((route: SubRoute, idx: number) => (
            <Route key={idx} path={route.path} component={route.component} />
          ))}
          <Route path="/configure/logistics/pickup/national/:adminRateId">
            <div className={classes.subRouteHeader}>
              <IconButton
                variant="contained"
                size="small"
                component={Link}
                to={`/configure/logistics/pickup${window.location.search}`}
              >
                <ArrowBack />
              </IconButton>
              <Typography className={classes.subRouteTitle}>
                {tabValue === 'national'
                  ? 'Editar Dirección de Tienda Nacional'
                  : 'Editar Dirección de Tienda Internacional'}
              </Typography>
            </div>
            <Divider className={classes.divider} />
            <LogisticPickupNewNational />
          </Route>
          <Route path="/configure/logistics/pickup/international/:adminRateId">
            <div className={classes.subRouteHeader}>
              <IconButton
                variant="contained"
                size="small"
                component={Link}
                to={`/configure/logistics/pickup${window.location.search}`}
              >
                <ArrowBack />
              </IconButton>
              <Typography className={classes.subRouteTitle}>
                {tabValue === 'national'
                  ? 'Editar Dirección de Tienda Nacional'
                  : 'Editar Dirección de Tienda Internacional'}
              </Typography>
            </div>
            <Divider className={classes.divider} />
            <LogisticPickupNewInternational />
          </Route>
        </Switch>
      </div>
      <FilterModal
        typeFilter={tabValue}
        open={openModalFilter}
        handleCloseModal={handleCloseModal}
        handleFilter={handleFilter}
        ignoreStoreCountryP={tabValue === 'national' ? false : true}
        filterIsEmpty={Object.keys(filter).length === 0}
        dataFilter={filter}
      />
    </>
  );
}
